import { FieldErrorsImpl, UseFormClearErrors, UseFormSetValue } from 'react-hook-form';
import { AdvancedTagMapping } from '../../types';
import { DropdownData } from 'src/types/dropdown-data';
import { Controller } from 'src/types/controllers/controller';
import { LabelingTypeEnum } from 'src/types';

export type DataType = {
  modeStatePredefined: DropdownData;
  setpointOutputPredefined: DropdownData;
  modeStateRange: DropdownData;
  setpointOutputRange: DropdownData;
};

export type DataTypeState = {
  value: DropdownData;
  loaded: boolean;
};

export enum CONTROLLABLE {
  YES = 'YES',
  NO = 'NO',
}

export enum ALLOWED_INPUTS {
  PREDEFINED = 'PREDEFINED',
  RANGE = 'RANGE',
}

export enum DATA_TYPES {
  INTEGER = 'INTEGER',
  BOOLEAN = 'BOOLEAN',
  FLOAT = 'FLOAT',
}

export enum RELEVANT_MODES {
  DO_NOT_RESTRICT = 'DO_NOT_RESTRICT',
}

export enum TagType {
  MODE = 'mode',
  STATE = 'state',
  SETPOINT = 'setpoint',
  OUTPUT = 'output',
  ALARM = 'alarm',
  SENSOR = 'sensor', // backend expects sensor_data
  CALCULATED = 'calculated',
}

export type ModalTableRowData = {
  index: number;
};

export type CustomErrors = {
  [key: string]: { message: string[] };
};

export type UserDefinedValue = {
  value: number;
  category: string | null;
  name: string | null;
  index?: number;
  valueFlag?: boolean | null;
  gatewayId: string;
  tagId: string;
  isOperational?: boolean;
};

export type UserDefinedValueWithCustomId = UserDefinedValue & {
  id: string;
};

export type FormattedSubmitData = {
  dataType: string;
  rawInputName?: string;
  displayName: string;
  fallbackValue: string | number;
  labellingType: LabelingTypeEnum;
  advancedTagMapping: {
    controllerId: string | null;
    allowedInputs: string;
    dataTypeTagMapping: string;
    controllable: boolean;
    relevantMode: UserDefinedValue[] | string | null;
    minimumValue: number | null;
    maximumValue: number | null;
    userDefinedValues: UserDefinedValue[];
    maximumDecimal: number | null;
  };
};

export type ModalTableProps = {
  handleRemoveRow: (index: number) => void;
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: string;
      controller: string;
      allowedInputs: string;
      dataType: string;
      controllable: string;
    }>
  >;
  customErrors: CustomErrors | undefined;
  clearErrors: UseFormClearErrors<AdvancedTagMapping>;
  areTableValuesUnique: (
    value: string,
    index: number,
    maxDecimal: number | null,
    newValues: { key: number; value: string }[] | null
  ) => {
    value: boolean;
    nonUniqueValueIndices: number[];
  };
  setValue: UseFormSetValue<AdvancedTagMapping>;
  values: AdvancedTagMapping;
};

export type CategoryData = {
  mode: DropdownData;
  state: DropdownData;
};

export type RelevantModeState = {
  labels: string[];
  values: UserDefinedValueWithCustomId[];
  loaded: boolean;
};

export type RelevantModeResponseBody = {
  displayName: string;
  minimumValue: number;
  maximumValue: number;
  tagId: string;
  userDefinedValues: UserDefinedValue[];
};

export type UpdatedInput = {
  inputId: string;
  controllerId: string;
  userDefinedValues: UserDefinedValue[];
  minimumValue: string;
  maximumValue: string;
  dataType: string;
  controllable: boolean | null;
};

export type ModalProps = {
  modalState: {
    open: boolean;
    inputId: string;
    tagType: string;
    tagDisplayName: string;
    controllers?: Controller[];
    setUpdatedInputs: React.Dispatch<React.SetStateAction<UpdatedInput[]>>;
  };
  onClose: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      inputId: string;
      tagType: string;
      tagDisplayName: string;
      controllers?: Controller[];
      setUpdatedInputs: React.Dispatch<React.SetStateAction<UpdatedInput[]>>;
    }>
  >;
  gatewayId: string;
  disableControllerFields?: boolean;
  controllableHelperText?: string;
  isStreamMLite?: boolean;
  isIntegralert?: boolean;
};
